/* ETR · UNIVERSO RARO — microinteracciones. Sin librerías. ~2 KB.
   - Ojos que miran al cursor (solo dispositivos con ratón).
   - El bicho de la ficha da un saltito al añadir al carrito.
   - Ovni que cruza una vez por sesión (lo pinta la sección ETR · Universo raro si está activado).
   - Carrito lateral: personaje y frase (esto no es movimiento: funciona siempre).
   Las animaciones se desactivan con prefers-reduced-motion. */
(function () {
  // 0) Carrito lateral: coloca el personaje (carrito vacío) y la frase bajo "Pagar".
  //    No es movimiento, así que va antes del corte por reduced-motion.
  var tpl = document.getElementById('EtrUCartTpl');
  var drawer = document.querySelector('cart-drawer');
  if (tpl && drawer) {
    var deco = function () {
      var h = drawer.querySelector('.cart__empty-text');
      var e = tpl.content.querySelector('[data-etr="empty"] .etr-u');
      if (h && e && !drawer.querySelector('.etr-u-cart-empty')) h.parentNode.insertBefore(e.cloneNode(true), h);
      /* 25-oct-2026: si hay pago rápido, la frase va debajo de esos botones */
      var ctas = drawer.querySelector('.etr-express') || drawer.querySelector('.cart__ctas');
      var n = tpl.content.querySelector('.etr-u-cart-note');
      if (ctas && n && !drawer.querySelector('.etr-u-cart-note')) ctas.insertAdjacentElement('afterend', n.cloneNode(true));
    };
    deco();
    new MutationObserver(deco).observe(drawer, { childList: true, subtree: true });
  }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;

  // 1) Ojos que miran
  var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (finePointer) {
    var eyes = document.querySelectorAll('.etr-u-eye');
    if (eyes.length) {
      var raf = null, mx = 0, my = 0;
      window.addEventListener('pointermove', function (e) {
        mx = e.clientX; my = e.clientY;
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          eyes.forEach(function (eye) {
            var r = eye.getBoundingClientRect(); if (!r.width) return;
            var dx = mx - (r.left + r.width / 2), dy = my - (r.top + r.height / 2);
            var d = Math.max(1, Math.hypot(dx, dy)), k = Math.min(3, d / 60);
            var svg = eye.querySelector('svg'); if (!svg) return;
            eye.classList.add('is-watching');
            svg.style.transform = 'translate(' + (dx / d * k).toFixed(2) + 'px,' + (dy / d * k).toFixed(2) + 'px)';
          });
        });
      }, { passive: true });
    }
  }

  // 2) Saltito del bicho al añadir al carrito (no bloquea nada: solo una clase)
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    var critter = document.querySelector('.etr-u-product');
    if (!critter) return;
    setTimeout(function () {
      critter.classList.remove('is-happy'); void critter.offsetWidth; critter.classList.add('is-happy');
    }, 350);
  }, true);

  // 3) Ovni: se quita del DOM al terminar y no vuelve en la misma sesión
  var ufo = document.querySelector('.etr-ufo-pass');
  if (ufo) {
    var seen = false;
    try { seen = !!sessionStorage.getItem('etrUfo'); sessionStorage.setItem('etrUfo', '1'); } catch (err) {}
    if (seen) { ufo.remove(); }
    else {
      ufo.addEventListener('animationend', function () { ufo.remove(); });
      ufo.classList.add('is-go');
    }
  }
})();
